import { c as _c } from "react/compiler-runtime";
import { DrawerSelect } from '@/modules/shared/components/filter-drawer/filter-drawer';
import { useNetworkOptions } from '@/modules/workstream/hooks/use-network-options';
import type { NetworkSelectProps } from './network-select';
function NetworkSelectDrawer(t0) {
  const $ = _c(6);
  const {
    networks,
    setNetworks
  } = t0;
  let t1;
  if ($[0] !== setNetworks) {
    t1 = values => {
      setNetworks(values);
    };
    $[0] = setNetworks;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleChange = t1;
  const {
    options
  } = useNetworkOptions();
  let t2;
  if ($[2] !== handleChange || $[3] !== networks || $[4] !== options) {
    t2 = <DrawerSelect value={networks} onChange={handleChange} label="Networks" options={options} multiselect={true} enableSelectAll={true} selectAllLabel="Select All" />;
    $[2] = handleChange;
    $[3] = networks;
    $[4] = options;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}
export { NetworkSelectDrawer };